/**
 * @file Created on Wed Aug 08 2018
 * @author SKu
 */
import Modal from './Modal';
export default Modal;